let tabs = () => {

    let module = {},
        htmlbody,

        attachEvents = (switcher, content) => {


            switcher.on('click', (e) => {
                e.preventDefault();
                var activeTab = $($(e.currentTarget).attr('href'));
                var currentCardContainer = activeTab.find('.card-container');

                switcher.removeClass('active');
                $(e.currentTarget).addClass('active');

                content.removeClass('active');
                content.hide();

                activeTab.show();
                activeTab.css('height', 'auto');
                setTimeout(() => {
                    activeTab.addClass('active');
                }, 50);

                window.location.hash = $(e.currentTarget).attr('href');

                if (typeof ga === 'function') {
                    ga('send', 'pageview', location.pathname + location.search + location.hash);
                }

                htmlbody.animate({
                    scrollTop : switcher.offset().top - 30
                }, 1000);

            });


        },

        init = () => {

            var tabSwitcher = $('.js-tab-switcher a'),
                tabContent = $('.js-tab');

            if(!tabSwitcher.length) {
                return;
            }

            htmlbody = $('html,body');

            // If we have #slug set in url, open the slug tab if it exists
            if(window.location.hash) {

                //Decode hash to work with non-ASCII characters
               const decodeHash = decodeURIComponent(window.location.hash);

                //console.log(window.location.hash);
                // Select active tab
                tabSwitcher.removeClass('active');
                $("a[href='"+decodeHash+"']").addClass('active');

                // Select active tab content
                var activeTab = $(decodeHash);
                var currentCardContainer = activeTab.find('.card-container');
                tabContent.removeClass('active');
                activeTab.addClass('active');

                if (typeof ga === 'function') {
                    ga('send', 'pageview', location.pathname + location.search + location.hash);
                }

                htmlbody.animate({
                    scrollTop : tabSwitcher.offset().top - 30
                }, 1000);
            }

            attachEvents(tabSwitcher, tabContent);
        }

    module.init = init;

    return module;

}

export default tabs();
